import axios from 'axios';
import {
  FinalDocumentAdmissionModel, NonWorkingDaysModel
} from 'app/edozvola/cases/final-document-admission/model/final-document-admission.model';

export const saveFinalDocumentAdmissionDate = async (idCase: string, finalDocumentAdmission: FinalDocumentAdmissionModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/cases/${idCase}/final-document-admission-date`, finalDocumentAdmission)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const getFinalDocumentAdmissionDate = async (idCase: string): Promise<FinalDocumentAdmissionModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/${idCase}/final-document-admission-date`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const determineIfDayIsNonWorking = async (dayToCheck: Date): Promise<NonWorkingDaysModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/non-working-days`, dayToCheck)
      .then(result => resolve(result.data))
      .catch(error => reject(error));
  });
};

